"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WPTransactionFailedContract = void 0;
const events_1 = require("@getgreenline/events");
const WPCNPFailedTransactionEventDataContract_1 = require("./WPCNPFailedTransactionEventDataContract");
class WPTransactionFailedContract extends events_1.EventsV2.EventModels.EventContractV2 {
    constructor(params) {
        super(params);
        this.isCNP = params.isCNP;
        this.wpTransaction = events_1.GreenlineEvent.create(WPCNPFailedTransactionEventDataContract_1.WPCNPFailedTransactionEventDataContract, params.wpTransaction);
    }
}
exports.WPTransactionFailedContract = WPTransactionFailedContract;
//# sourceMappingURL=WPTransactionFailedContract.js.map